import React from "react";
import { FaAsterisk } from "react-icons/fa";
import Select, { Props } from "react-select";

export interface OptionType {
  label: string;
  value: string | number;
}
export type SelectComponentPropsModel<isMulti extends boolean> = Props<
  OptionType,
  isMulti
> & {
  label?: string;
};

const SelectComponent = <T extends boolean>(
  props: SelectComponentPropsModel<T>
) => {
  const { label, name, required, ...rest } = props;
  return (
    <>
      <div className="flex">
        {label ? (
          <label htmlFor={name} className="block truncate mb-1.5 text-white">
            {label}
          </label>
        ) : null}
        {required ? (
          <FaAsterisk className="fill-primary-red-50 pt-1" size={12} />
        ) : (
          <></>
        )}
      </div>
      <Select
        name={name}
        {...rest}
        styles={{
          control: (baseStyles) => ({
            ...baseStyles,
            height: "46px",
            borderRadius: "6px",
            fontSize: "14px",
          }),
          option: (base) => ({
            ...base,
            fontSize: "14px",
          }),
        }}
      />
    </>
  );
};
export default SelectComponent;
